import { Box, ThemeProvider, Toolbar, Typography, createTheme, useTheme, CssBaseline } from '@mui/material'
import { useState, useEffect } from 'react';
import Routing from './routing';
import Header from './component/view/Sidebar';
import { initializeDefaultProjectContext } from './utils/storageInitializer';
import "./App.scss";

const App = () => {
  const themes = useTheme();
  const [open, setOpen] = useState(true);

  // Initialize localStorage with default project/site context on app startup
  useEffect(() => {
    initializeDefaultProjectContext();
  }, []);
  const theme = createTheme({
    palette: {
       background: {
      default: '#F8F8F8'
      },
      text: {
        primary: '#151E15', // Default primary text color
        secondary: '#666666', // Default secondary text color
        disabled: '#888888', // Default disabled text color
      },
    },
    typography: { 
      fontFamily: "Poppins",
      fontSize: 14,
      // fontWeightLight: 300,
      // fontWeightRegular: 400,
      // fontWeightMedium: 600,
      // fontWeightBold: 500,
      button: {
        textTransform: "none",
      },

   
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Header/>
        <Box sx={{ display: "flex", flexGrow: 1 }}>
          <Routing open={open} />
        </Box>
        <footer className='footer'>
        <Typography className='footer-heading'>
          © Copyright 2024. Darukaa Earth. All Rights Reserved.
        </Typography>
      </footer>
      </Box>
    </ThemeProvider>
  )
}

export default App;
